import mainStyle from '../org-management.module.scss';

import { useState, useCallback } from 'react';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';

// Components
import { ButtonGroup } from 'react-bootstrap';
import Button from 'components/Button';
import InlineTitle from 'components/InlineTitle';
import ButtonWithIcon from 'components/ButtonWithIcon';
import InputWithIcon from 'components/InputWithIcon';

import { userPriv, userInvalid } from "utils/privilege.util";
import { userType, userPrivilege } from 'const/nuclias/user';
import { actionsLabel, getDefaultModalStatus } from "../const";

const OrgTreeToolbarBox = ({
  info,
  handleModals,
  viewStatus,
  setViewStatus,
  seachValue,
  setSearchValue,
}) => {
  const { t } = useTranslation();
  const modalStatus = getDefaultModalStatus(info);
  const privilege = {
    createSite: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
    createTag: !userPriv(userPrivilege.manager) && !userPriv(userType.siteTag),
  }

  return (
    <>
      <div className={`d-flex justify-content-between ${mainStyle['toolbar-box-container']}`}>
        <div>
          <ButtonGroup>
            <ButtonWithIcon
              label={t('b31fb8458b')}
              iconClassName='icon-expand'
              onClick={() => setViewStatus({ ...viewStatus, collapse: false })}
            ></ButtonWithIcon>
            <ButtonWithIcon
              label={t('89f1157dd5')}
              iconClassName='icon-collapse'
              onClick={() => setViewStatus({ ...viewStatus, collapse: true })}
            ></ButtonWithIcon>
          </ButtonGroup>

          {modalStatus.previewTreeSearch.show &&
            <Button
              style={{ marginLeft: '10px' }}
              label={t('0a5a55d93a')}
              disabled={viewStatus?.treeView}
              onClick={() => {
                setViewStatus({ ...viewStatus, treeView: true })
                setSearchValue('');
              }}
            />
          }
        </div>

        <InlineTitle isNonUnderline>
          {modalStatus.previewTreeSearch.show &&
            <InputWithIcon
              type='Search'
              iconPosition='left'
              placeholder={t('2047ee55cc')}
              value={seachValue}
              onChange={e => {
                setViewStatus({ ...viewStatus, treeView: false })
                setSearchValue(e.target.value);
              }}
              onFocus={() => { }}
              onBlur={() => { }}
              iconClassName='icon-search'
              iconOnClick={() => { }}
            />}

          <ButtonWithIcon
            label={t(actionsLabel.createSite)}
            iconClassName='icon-site'
            disabled={!privilege?.createSite}
            onClick={() => handleModals({ modal: 'site', status: true, type: 'create', editObj: { orgId: info.orgDs.id } })}
          ></ButtonWithIcon>
          <ButtonWithIcon
            label={t(actionsLabel.createTag)}
            iconClassName='icon-tag'
            disabled={!privilege?.createTag}
            onClick={() => handleModals({ modal: 'tag', status: true, type: 'create', editObj: { orgId: info.orgDs.id } })}
          ></ButtonWithIcon>

        </InlineTitle>

      </div>
    </>
  );
};

export default OrgTreeToolbarBox;
